module.exports = __webpack_public_path__ + "static/media/microcentrifuge_topview.ddf64596.svg";